module.exports = __webpack_public_path__ + "static/media/not_fix_to_wall.201f3fb8.png";